
import {Options, Vue} from 'vue-class-component';

@Options({
    components: {
    },
    created() {
        this.url = window.location.host.includes('test') ? 'https://test-api.feihua100.com' : 'https://api.feihua100.com';
    }
})
export default class Home extends Vue {
    url = '';

    gotoxieyi() {
        // 用户服务协议
        this.$router.push({
            path: '/policyprotocol',
        });
    }

    gotoyinsi() {
        // 个人信息保护政策
        this.$router.push({
            path: '/policy',
        });
    }
}
